export default class PBFFeature {
    constructor(pbf, end, extent, keys, values) {
        this.properties = {};
        this.extent = extent;
        this.type = 0;

        // Private
        this._pbf = pbf;
        this._geometry = -1;
        this._keys = keys;
        this._values = values;

        pbf.readFields(this.readFeature.bind(this), this, end);
    }

    readFeature(tag, feature, pbf) {
        if (tag === 1) feature.id = pbf.readVarint();
        else if (tag === 2) this.readTag(pbf, feature);
        else if (tag === 3) feature.type = pbf.readVarint();
        else if (tag === 4) feature._geometry = pbf.pos;
    }

    readTag(pbf, feature) {
        const end = pbf.readVarint() + pbf.pos;

        while (pbf.pos < end) {
            const key = feature._keys[pbf.readVarint()];
            const value = feature._values[pbf.readVarint()];
            feature.properties[key] = value;
        }
    }

    loadGeometry(ratio = 1000, dimension = 2) {
        const pbf = this._pbf;
        pbf.pos = this._geometry;
        const end = pbf.readVarint() + pbf.pos;
        let cmd = 1;
        let length = 0;
        let x = 0;
        let y = 0;
        let z = 0;
        const lines = [];
        let line;
        while (pbf.pos < end) {
            if (length <= 0) {
                const cmdLen = pbf.readVarint();
                cmd = cmdLen & 0x7;
                length = cmdLen >> 3;
            }

            length--;

            if (cmd === 1 || cmd === 2) {
                x += pbf.readSVarint();
                y += pbf.readSVarint();
                if (dimension === 3) {
                    z += pbf.readSVarint();
                }

                if (cmd === 1) { // moveTo
                    if (line) lines.push(line);
                    line = [];
                }

                const coords = [x / ratio, y / ratio];
                if (dimension === 3) {
                    coords.push(z / 1000); // z值保留3位小数
                }
                line.push(coords);
            } else if (cmd === 7) {
                // Workaround for https://github.com/mapbox/mapnik-vector-tile/issues/90
                if (line) {
                    line.push(line[0].slice()); // closePolygon
                }
            } else {
                throw new Error(`unknown command ${cmd}`);
            }
        }

        if (line) lines.push(line);

        let geometry;
        if (this.type === 1 && lines.length > 0) { // 点
            geometry = {
                type: 'Point',
                coordinates: lines[0][0]
            };
        } else if (this.type === 2 && lines.length > 0) { // 线
            geometry = {
                type: 'LineString',
                coordinates: lines[0]
            };
        } else if (this.type === 3 && lines.length > 0) { // 面
            geometry = {
                type: 'LineString',
                coordinates: lines
            };
        }

        return geometry;
    }
}
